export const contact = {
    phone: '4072051114',
    location: '2627 S Hwy 27, Clermont, FL 34711, United States',
    phoneDisplay: '(407) 205-1114',
    faxDisplay: '(407) 845-9347',
    email: 'office@clermontkidsdentistry.com',
    link: 'https://maps.app.goo.gl/mQJgSg6SbKk7do7XA'
};
